<template>
  <div id="certificationSuccess">
    <div class="page_bd page_bd_spacing">
      <div class="certification_step">
        <div class="weui-flex">
          <div class="weui-flex__item">
            <i class="active"></i>
            <div class="placeholder">身份证信息提交</div>
          </div>
          <div class="weui-flex__item">
            <i class="active"></i>
            <div class="placeholder">认证完成</div>
          </div>
        </div>
      </div>
    </div>
    <img class="success_img"
         :src="successImg"
         alt="">
    <div class="success_title">实名认证成功</div>
    <router-link to="/" class="success_btn">返回</router-link>
  </div>
</template>

<script>
export default {
  name: 'certificationSuccess',
  data () {
    return {
      successImg: this.$store.state.ossLink + 'tixian_icon_success.png'
    }
  },
  methods: { }
}
</script>

<style scoped lang="less">
  .page_bd {
    padding: 20px 15px;
    background-color: #fff;
  }
  .certification_step{
    width: 405px;
    padding: 95px 15px 50px;
    background-color: #fff;
    text-align: center;
    margin: 0 auto;
    .weui-flex{
      position: relative;
      .weui-flex__item{
        position: absolute;
        width: 22px;
        z-index: 2;
      }
      i{
        display: block;
        width: 14px;
        height: 14px;
        border: solid 8px #ccc;
        background-color: #ccc;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
      }
      i.active{
        border-color: #f26d06;
        background-color: #fff;
      }
      .weui-flex__item:nth-child(1){
        left: 0;
      }
      .weui-flex__item:nth-child(2){
        right: 0;
      }
      &:after{
        content: ' ';
        position: absolute;
        left: 0;
        top: 11px;
        display: block;
        width: 100%;
        height: 4px;
        background-color: #f26d06;
      }
      .placeholder{
        position: absolute;
        left: 50%;
        top: -48px;
        width: 300px;
        margin-left: -150px;
        font-size: 26px;
        color: #333;
      }
    }
  }
  .success_img {
    margin-top: 250px;
    width: 200px;
    height: 200px;
    margin-left: calc(50% - 100px);
  }
  .success_title {
    width: 100%;
    margin: 40px auto;
    font-size: 36px;
    text-align: center;
    color: #666666;
  }
  .success_msg {
    width: 100%;
    margin: 40px auto;
    font-size: 26px;
    color: #999999;
    text-align: center;
  }
  .success_btn {
    display: block;
    margin-top: 150px;
    width: 258px;
    height: 88px;
    background-color: #ffffff;
    border-radius: 10px;
    margin-left: calc(50% - 129px);
    text-align: center;
    line-height: 88px;
    font-size: 30px;
    color: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/certification/success.vue